module.exports = __webpack_public_path__ + "img/noah.65fd6fb0.png";